module.exports = __webpack_public_path__ + "fonts/CrimsonText-BoldItalic-3.42e41d53.ttf";